export default {
  APP_NAME: 'myyola',
};
